export default __webpack_public_path__ + "static/media/eventopsLogo.927cb104.png";